import { createContext, useContext, useState } from 'react';

export const LA_SCOPES = [
  { slug: 'tvca', label: 'All Tees Valley', short: 'TVCA' },
  { slug: 'stockton', label: 'Stockton-on-Tees', short: 'Stockton' },
  { slug: 'middlesbrough', label: 'Middlesbrough', short: 'Middlesbrough' },
  { slug: 'redcar', label: 'Redcar & Cleveland', short: 'Redcar' },
  { slug: 'hartlepool', label: 'Hartlepool', short: 'Hartlepool' },
  { slug: 'darlington', label: 'Darlington', short: 'Darlington' },
];

const LAScopeContext = createContext({ laScope: 'tvca', setLAScope: () => {}, scopes: LA_SCOPES });

export function LAScopeProvider({ children }) {
  const [laScope, setScope] = useState(() => localStorage.getItem('adoptic_la_scope') || 'tvca');
  const setLAScope = (slug, { manual = false } = {}) => {
    if (manual) sessionStorage.setItem('adoptic_scope_touched', '1');
    localStorage.setItem('adoptic_la_scope', slug);
    setScope(slug);
  };
  return (
    <LAScopeContext.Provider value={{ laScope, setLAScope, scopes: LA_SCOPES }}>
      {children}
    </LAScopeContext.Provider>
  );
}

export const useLAScope = () => useContext(LAScopeContext);
